import { render } from "./CardsNecesidades.vue?vue&type=template&id=5a0a754f"
import script from "./CardsNecesidades.vue?vue&type=script&lang=js"
export * from "./CardsNecesidades.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__